module.exports = __webpack_public_path__ + "img/strategy_martin_grey.e51c425a.svg";